<template>
  <div>
    <b-overlay
      :show="userstock.length <= 0"
      opacity="0.9"
      spinner-variant="dark"
      spinner-small
      rounded
    >
      <template v-slot:overlay>
        <div class="text-center">
          <b-icon-circle
            variant="dark"
            font-scale="3"
            animation="throb"
          ></b-icon-circle>
          <h4>Retrieving Questions... Wait a Sec</h4>
        </div>
      </template>
      <b-container fluid>
        <b-button class="mb-3" @click="$router.go(-1)" variant="outline-dark">
          <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
          Back
        </b-button>
        <b-row>
          <b-col class="p-0">
            <!-- <h3 class="text-center" v-if="$route.query.type == 'stocker'">
              This Stocker has uploaded {{ questionsarray.length }} Questions in
              {{ $route.query.subject }} {{ $route.query.course }}
            </h3> -->
            <!-- <h3 v-else class="text-center">
              You have Uploaded {{ questionsarray.length }} Questions
            </h3> -->
            <div class="p-0 mt-5" v-if="userstock.length > 0">
              <!-- <h2 class="text-center">{{ userstock[0].name }}</h2>
              <h4 class="text-center" v-if="userstock.length > 0">
                This Table has {{ userstock[0].data.length }} rows
              </h4> -->
              <tabler2
                v-if="userstock.length > 0"
                :clearance="Number($route.query.clearance)"
                :module="$route?.query?.module"
                class="esq m-1 p-0"
                :datas="userstock[0].data"
                :fields="userstock[0].fields"
              ></tabler2>
            </div>
            <div class="text-center mb-3">
              <b-modal
                id="modal-flush-questions"
                centered
                title="Confirm Flushing Questions"
                ok
                ok-variant="success"
                cancel-variant="danger"
                @ok="flushQuestions()"
              >
                <template v-slot:modal-ok> Flush Questions </template>
                <p>
                  Are you sure you want to Flush this Questions? Every Question
                  here will be deleted!
                </p>
              </b-modal>
              <b-button
                class="mt-lg-3 action-button ml-lg-2"
                @click="confirmFlush"
                variant="info"
                ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
                Flush all Questions
              </b-button>
              <b-overlay
                :show="preparing"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="inline-overlay"
              >
                <b-button
                  class="mt-lg-3 action-button ml-lg-2 mt-3"
                  @click="prepareDownloadtxt"
                  variant="success"
                  ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
                  Download Questions in Txt
                </b-button>
              </b-overlay>
              <!-- <a
                :href="downloadlink"
                v-if="prepared"
                target="_blank"
                class="text-center"
                download
                ><b-button
                  class="mt-lg-3 action-button ml-lg-2 mt-3"
                  variant="success"
                  ><b-icon-file-earmark-arrow-down></b-icon-file-earmark-arrow-down>
                  Click to Download now
                </b-button></a
              > -->
            </div>

            <b-form-group class="nested-form-group" label-for="institution">
              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                  type="search"
                  v-model="searchQuery"
                  @keyup="searchFilter"
                  @focus="searching = true"
                  placeholder="Search question"
                ></b-form-input>
                <b-icon
                  font-scale="1.5"
                  class="close-button"
                  @click="closeSearch"
                  variant="secondary"
                  icon="x"
                  ref="closebutton"
                ></b-icon>
              </b-input-group>
            </b-form-group>

            <p class="text-center">Click any question to edit</p>
            <search-list
              v-if="searching == true"
              :searchingfor="searchfor"
              :source="stockObj.source"
              :module="$route?.query?.module"
              :filtereddata="searchResult"
              @refetch="refetchQuestions"
              @clearSearch="clearField"
            />

            <div v-if="!searching">
              <b-row>
                <b-col
                  class="col-lg-4"
                  v-for="(question, index) in usedatas"
                  :key="question.track_id"
                >
                  <QuestionsForList
                    :key="question.track_id"
                    :question="question"
                    :clearance="$route.query.clearance"
                    :module="$route?.query?.module"
                    @refetch="refetchQuestions"
                    :sn="index + 1"
                    :source="stockObj.source"
                    class="questions-lister"
                  />
                </b-col>
              </b-row>
              <paginater
                :intervalnum="intervalnum"
                :pages="pages"
                :endnum="endnum"
                :endss="endss"
                :datalength="endss"
                @paginator="newPage"
                @changeInterval="effectInterval"
              ></paginater>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
  </div>
</template>

<script>
import QuestionsForList from "@/components/admin/QuestionsForList.vue";
import searchList from "@/components/admin/searchList";
import Tabler2 from "@/components/admin/Tabler2";
import { mapState, mapActions } from "vuex";
import store from "@/store";
import Paginater from "@/components/Paginater";

export default {
  components: {
    QuestionsForList,
    Tabler2,
    searchList,
    Paginater
  },

  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      stockingdata: [
        {
          data: []
        }
      ],
      dataretrieved: false,
      searching: false,
      searchQuery: "",
      searchResult: [],
      searchfor: "question",
      stockObj: [],
      prepared: false,
      unprepared: true,
      preparing: false,
      downloadlink: ""
    };
  },
  beforeRouteEnter(to, from, next) {
    let clearance = to.query.clearance;
    let type = to.query.type;
    let institution_id = to.query.institution_id;
    let category = to.query.category;
    let section = to.query.section;
    let identity = to.params.identity;
    let subtype = to.query.subtype;
    let subject = to.query.subject;
    let course = to.query.course;
    let source = to.query.source;
    let stocker = to.query.stocker;
    let organization = store.state.loginmaster.details.clearance_organization;
    let organization_id = store.state.loginmaster.details.clearance_organization_id;

    // stockobj = {

    // }

    store.dispatch("admin/fetchForQuestions", {
      type: type,
      clearance: clearance,
      stocker: stocker,
      institution_id: institution_id,
      identity: identity,
      category: category,
      section: section,
      subtype: subtype,
      subject: subject,
      source: source,
      course: course,
      organization,
      organization_id
    });

    next();
  },
  beforeRouteLeave(to, from, next) {
    this.setnextid(to.params.trackid).then(() => {
      next();
    });
  },
  created() {
    let mathjaxlink =
      this.environ == "development"
        ? "http://localhost/quicktest/plugins/Mathjax/MathJax.js?config=MML_HTMLorMML"
        : "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=MML_HTMLorMML";

    window.MathJax = {
      MathML: { extensions: ["mml3.js", "content-mathml.js"] }
    };
    let externalScript = document.createElement("script");
    externalScript.setAttribute("src", mathjaxlink);
    document.head.appendChild(externalScript);

    let curpage = 1;
    this.endnum = this.endnum * Number(curpage);
    this.pager = curpage;

    let stockobj = {};
    let organization = this.details.clearance_organization;
    let organization_id = this.details.clearance_organization_id;

    stockobj = {
      type: this.$route.query.type,
      clearance: this.$route.query.clearance,
      stocker: this.$route.query.stocker,
      institution_id: this.$route.query.institution_id,
      identity: this.$route.params.identity,
      category: this.$route.query.category,
      section: this.$route.query.section,
      subtype: this.$route.query.subtype,
      subject: this.$route.query.subject,
      source: this.$route.query.source,
      course: this.$route.query.course,
      organization,
      organization_id,
      origin: this.origin,
      environment: this.environ
    };

    this.stockObj = stockobj;
    // console.log(stockobj)
    this.queryForStocks(stockobj);
  },
  methods: {
    ...mapActions("admin", [
      "fetchForQuestions",
      "prepareForDownload",
      "flushForQuestions",
      "setnextid",
      "queryForStocks"
    ]),

    newPage(page) {
      // alert(page)
      this.pages = page;
      let newend = this.intervalnum * page;

      if (newend < this.endss) {
        this.endnum = newend;
        this.startnum = newend - this.intervalnum;
      } else {
        this.endnum = this.endss;
        this.startnum = newend - this.intervalnum;
      }
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
    clearField() {
      this.searchQuery = "";
      this.closeSearch();
    },

    refetchQuestions() {
      this.fetchForQuestions(this.stockObj);
      this.queryForStocks(this.stockObj);
    },

    searchFilter() {
      this.searching = true;
      let query = this.searchQuery;
      if(this.searchQuery.length == 0){
        this.clearField()
      }else{
        let re = new RegExp(`${query}`, "gi");
        let searchResult = this.questionsarray.filter(
          x => re.test(x.question) == true
        );
        this.searchResult = searchResult;
      }
      
    },
    closeSearch() {
      this.searching = false;
      this.searchQuery = "";
    },
    confirmFlush() {
      this.$bvModal.show("modal-flush-questions");
    },
    flushQuestions() {
      this.flushing = true;
      this.flushed = false;

      return this.flushForQuestions(this.stockObj).then(() => {
        this.flushed = true;
        this.refetchQuestions();
        this.$router.go(-1);
        // this.downloadlink = response[0];
        // this.tabledata = response[1];

        // console.log(response)
      });
    },
    prepareDownloadtxt() {
      this.preparing = true;

      this.prepareForDownload(this.stockObj).then(response => {
        this.prepared = true;
        this.unprepared = false;
        this.preparing = false;

        this.downloadlink = response;

        const blob = new Blob([response]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download =
          this.stockObj.identity + "-" + 'questions' + ".txt"; // Specify the filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    }
  },
  computed: {
    ...mapState({
      name: state => state.loginmaster.details.fullname,
      details: state => state.loginmaster.details,
      trackid: state => state.loginmaster.details.trackid,
      questionsarray: state => state.admin.questionsfor,
      userstock: state => state.admin.quesforstocks,
      environ: state => state.loginmaster.environ,
      origin: state => state.loginmaster.site_origin
    }),
    // getpager(){
    //   let pagers = this.$route.query.page

    //   return Number(pagers);
    // },
    usedatas() {
      return this.questionsarray.slice(this.startnum, this.endnum);
    },
    endss() {
      let end = this.questionsarray.length;
      return end;
    },
    ranger() {
      let ranger = Math.ceil(this.questionsarray.length / this.intervalnum);
      return ranger;
    }
  }
};
</script>

<style scoped>
.viewmore {
  background-color: rgb(241, 234, 234);
  border-radius: 100px;
  width: 50px;
  height: 50px;
  margin: 0px auto;
  box-shadow: 5px 5px 15px black;
  cursor: pointer;
}

.vmore {
  margin: 5px;
  padding: 10px;
}
.close-button {
  position: relative;
  left: -40px;
  top: 5px;
  cursor: pointer;
  z-index: 9999;
}
.questions-lister {
  width: 100%;
  height: max-content;
}

.page-buttons {
  width: 35px;
  height: 35px;
}
.active-page-btn {
  background-color: #00377b;
  color: white;
}
.button-pager-group {
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: thin;
}
.inline-overlay {
  display: inline;
}

@media screen and (max-width: 999px) {
  .questions-lister {
    width: 100%;
  }
  .page-buttons {
    width: 25px;
    height: 25px;
    padding: 0px 0px 0px 5px;
  }
}
</style>
